import { __rest } from "tslib";
import React from 'react';
import { cn } from '~/utils';
import { visuallyHiddenStyles } from '~/theme/utils.css';
const VISUALLY_HIDDEN_NAME = 'vulcanui-visually-hidden';
const VisuallyHidden = React.forwardRef((props, ref) => {
    const { children, className, as = 'span' } = props, restProps = __rest(props, ["children", "className", "as"]);
    const Comp = as || 'span';
    return (React.createElement(Comp, Object.assign({ className: cn(VISUALLY_HIDDEN_NAME, className, visuallyHiddenStyles), ref: ref }, restProps), children));
});
VisuallyHidden.displayName = 'VisuallyHidden';
VisuallyHidden.toString = () => `.${VISUALLY_HIDDEN_NAME}`;
export default VisuallyHidden;
//# sourceMappingURL=visually-hidden.js.map